export default __webpack_public_path__ + "static/media/justin.39b0fc96.png";